import * as React from "react";
import { Box, Grid } from "@mui/material";

export default function Calendar({ question, onAnswer = () => {} }) {
	const [answers, setAnswers] = React.useState([]);

	React.useEffect(() => {
		setAnswers([]);
	}, [question]);

	const handleToggleAnswer = (value) => {
		let newAnswers = [...answers];
		if (newAnswers.indexOf(value) === -1) {
			newAnswers.push(value);
		} else {
			newAnswers = newAnswers.filter((ans) => ans !== value);
		}

		setAnswers(newAnswers);

		const canProceed = newAnswers.length > 0;
		onAnswer({
			canProceed,
			answer: newAnswers,
		});
	};

	const getContent = () => {
		let content = [];
		for (let i = question.from; i <= question.to + question.dummy; i++) {
			content.push(
				<Grid
					item
					key={`calendar-select-${i}`}
					className={`calendar-choices ${
						answers.indexOf(i) >= 0 ? "selected" : ""
					}`}
					sx={{
						backgroundColor:
							i <= question.to ? "white" : "transparent",
						p: 1,
						width: `${100 / 8}%`,
						borderRadius: 1,
						fontWeight: "bold",
					}}
					id={`choice-${i}`}
					onClick={() =>
						i <= question.to ? handleToggleAnswer(i) : ""
					}
				>
					{i <= question.to ? i : ""}
				</Grid>
			);
		}
		return (
			<Grid container justifyContent="center" gap={0.8}>
				{content}
			</Grid>
		);
	};

	return (
		<React.Fragment>
			<Box
				className="choices-container"
				sx={{ px: 4, textAlign: "center" }}
			>
				{question.questionImage && (
					<img
						src={`https://s3.ap-southeast-2.amazonaws.com/static.lln.training/acsf3-short-quiz-resources/${question.questionImage}`}
						alt="Question Illustration"
						style={{ width: "100%", marginTop: "20px" }}
					/>
				)}

				<Box sx={{ mt: 1 }}>{getContent()}</Box>
			</Box>
		</React.Fragment>
	);
}
